
<nbc-breadcrumb></nbc-breadcrumb>
<div class="page-container-tbl">
  <div class="container-fluid-tbl">
    <div class="row-tbl">
      <business-unit></business-unit>
      <create-timesheet *ngIf="operationTalentDept"
                        [selectedBusinessUnit]="selectedBusinessUnit"
                        [departments]="departments"></create-timesheet>
    </div>

    <div *ngIf="operationTalentDept" class="row-tbl" [class.d-none]="showBUManageTCSection">
      <ops-tal-dept></ops-tal-dept>
    </div>



    <div *ngIf="financePayrollDept" class="row-tbl" [class.d-none]="showBUManageTCSection">
      <fin-pay-dept></fin-pay-dept>
    </div>   

    <div *ngIf="showBUManageOnboardingSection" class="row-tbl" [class.d-none]="!showBUManageOnboardingSection">
      <onboarding-tab></onboarding-tab>
    </div>

    <!--Div : Col :Exports Archive-->

    <div class="row-tbl" *ngIf="showPayrollExport">
      <app-archive-export></app-archive-export>
    </div>
  </div>
</div>
